import React, {useState} from "react";
import Table, {TableActionBar, TableCell, TableRow} from "@amzn/meridian/table";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import Link from "@amzn/meridian/link";
import Box from "@amzn/meridian/box";
import Column from "@amzn/meridian/column";
import {getTPSRequestTicketURL} from "../util/TicketUtils";
import Tag from "@amzn/meridian/tag";
import metricsToken from "@amzn/meridian-tokens/base/icon/metrics"
import downloadToken from "@amzn/meridian-tokens/base/icon/download-large"
import Tooltip from "@amzn/meridian/tooltip";
import Heading from "@amzn/meridian/heading";
import {TAT_TABLE_HEADERS} from "../../Constants";
import {exportToCsv} from "../../handler/CsvHandler";


export const TATDataTable = ({headers, dependencyMap, serviceName, region}) => {
    const [expandedRows, setExpandedRows] = useState([])
    const [toggle, setToggle] = useState(true);

    console.log("headers: ", headers);
    const updateExpandedRows = row => {
        const newExpandedRows = expandedRows.includes(row)
            ? expandedRows.filter(expandedRow => expandedRow !== row)
            : [...expandedRows, row]
        setExpandedRows(newExpandedRows)
    }

    // Unique list of dependencies
    const dependencies = dependencyMap.map(dependency => dependency.aaaApplicationName);

    const prepareTATCalculationsList = (dependencyMap) => {
        let simplifiedListOfAPIs = [];
        dependencyMap.forEach(service => {
            service.dataList.forEach(api => {
                simplifiedListOfAPIs = simplifiedListOfAPIs.concat({
                    aaaApplicationName : service.aaaApplicationName || "",
                    apiName: api.serviceName || "",
                    timeout: api.timeout || "",
                    currentTps: api.currentTps || "0",
                    requiredTps : api.requiredTps || "0",
                    link : api.link || "-",
                    graphImagelink : api.graphImagelink || "-",
                });
                console.log(simplifiedListOfAPIs);
            })
        })
        return simplifiedListOfAPIs;
    };

    const exportDataToCsv = () => {
        let dataFromResponse = prepareTATCalculationsList(dependencyMap);
        console.log("dataFromResponse ", dataFromResponse.map(Object.values));
        //export to CSV Function with preprocessed information
        exportToCsv({
            title: `${serviceName}-MetricsMate`,
            headers: TAT_TABLE_HEADERS,
            rows: dataFromResponse.map(Object.values)
        })};


    function renderDependency(dependencyName) {
        const dependency = dependencyMap.find(dependency => dependencyName === dependency.aaaApplicationName);
        return [
            <TableRow highlightOnHover={true}>
                <TableCell alignmentVertical="top" width={60}>
                    <Button type="icon" size="small" onClick={() => updateExpandedRows(dependencyName)}>
                        {expandedRows.includes(dependencyName) ?
                            (<Icon tokens={chevronDownSmallTokens}>Collapse rows</Icon>) :
                            (<Icon tokens={chevronRightSmallTokens}>Expand rows</Icon>)}
                    </Button>
                </TableCell>
                <TableCell alignmentVertical="top">
                    {dependencyName}
                </TableCell>
                <TableCell>
                    <Tag type={dependencyName === serviceName ? "success" : "theme"}>
                        {dependencyName === serviceName ? "Service" : "Dependency"}
                    </Tag>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>
                    {/* Link to cut Ticket */}
                    <Link
                        href={getTPSRequestTicketURL(serviceName, region, dependency.dataList, {
                            category: dependency.category,
                            type: dependency.type,
                            item: dependency.item
                        })}
                        target="_blank" rel="noopener noreferrer">
                        Raise TPS Request
                    </Link>
                </TableCell>
                <TableCell></TableCell>
            </TableRow>
        ].concat(expandedRows.includes(dependencyName) ? renderAPIs(dependency) : [])
    }

    function renderAPIs(dependency) {
        return dependency.dataList.map(dataList => (
            <TableRow highlightOnHover={true}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>{dataList.serviceName}</TableCell>
                <TableCell>{dataList.timeout}</TableCell>
                <TableCell>{dataList.currentTps}</TableCell>
                <TableCell>{dataList.requiredTps}</TableCell>
                <TableCell>
                    {toggle ?
                        <a href= {dataList.link} target="_blank" rel="noopener noreferrer">
                            <img  alt={"iGraph"} src={dataList.graphImageLink}/>
                        </a> :
                        <Link href={dataList.link} target="_blank" rel="noopener noreferrer">Link</Link>}
                </TableCell>
            </TableRow>));
    }

    return (
        <Column>
        <Box spacingInset="large none none large">
        </Box>
        <Table headerRows={2} showStripes={false} showDividers={true}>
            <TableActionBar widths={["grid-1", "fill", "grid-1", "grid-1"]}>
                <Heading level={3} type="h400" alignment="left">Results</Heading>
                <div/>
                <Tooltip position="left" title="Download as CSV" id="graphTooltip">
                    <Button type="icon" onClick={exportDataToCsv}>
                        <Icon tokens={downloadToken}/>
                    </Button>
                </Tooltip>
                <Tooltip position="left" title="Toggle Metric Graphs" id="graphTooltip">
                    <Button type="icon" onClick={() => setToggle(!toggle)}>
                        <Icon tokens={metricsToken}/>
                    </Button>
                </Tooltip>
            </TableActionBar>
            {/* Nested Header Row */}
            <TableRow>
                <TableCell>Service</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>Calculations</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>Graphs</TableCell>
            </TableRow>
            {/* Header Row */}
            <TableRow>
                <TableCell width={60}>
                    {/* Empty table cell to hold the expandable Icon button */}
                </TableCell>
                <TableCell sortColumn="name" columnSpan={2}>AAA Application Name</TableCell>
                <TableCell sortColumn="api">API Name</TableCell>
                <TableCell sortColumn="timeout">Timeout (ms)</TableCell>
                <TableCell sortColumn="currTPS">Current TPS</TableCell>
                <TableCell sortColumn="rTPS">Required TPS</TableCell>
                <TableCell sortColumn="graph">Metric Graph</TableCell>
            </TableRow>
            { dependencies.map(dependencyName => renderDependency(dependencyName)) }
        </Table>
        </Column>
    );
};


// WEBPACK FOOTER //
// ./src/components/tat-calculator/TATDataTable.js